export default __webpack_public_path__ + "static/media/uin_tags.9e100880.png";